import axios from '@/plugins/axios';
import StateUtils from '@/utils/StateUtils.js';

export default {
  /**
   * Builds a standardized payload for the API.
   * Handles both creator and cart store objects.
   */
  buildPayload (wardrobeSaveConfig, localState = {}, shouldSendDoors = true, shouldSendInventory = true) {
    const config = JSON.parse(JSON.stringify(wardrobeSaveConfig));

    let combinedState = {
      wardrobe: {
        ...(config.wardrobe || {}),
        ...(localState.wardrobe || {})
      },
      doors: { items: [], number: 0 },
      inventory: []
    };

    if (shouldSendDoors) {
      const baseDoors = config.doors || { items: [], number: 0 };
      const localDoors = localState.doors || {};

      combinedState.doors = {
        ...baseDoors,
        ...localDoors
      };
    }

    if (shouldSendInventory && Array.isArray(config.inventory)) {
      combinedState.inventory = [...StateUtils.getInventoryIDs(config.inventory)];
    }

    return combinedState;
  },

  async fetchPrice (payload) {
    try {
      const response = await axios.post(
        '/api/prices/calculate',
        payload
      );

      if (!response.data || response.status !== 200) {
        throw new Error('Invalid API response');
      }

      return response.data;
    } catch (error) {
      console.error('PriceService Error:', error);
      throw error;
    }
  }
};
